import React, { useMemo } from 'react'
import { SurveyChartCard } from '@diversioteam/diversio-ds'

import { useGetSingleFreeTextInfinite } from 'hooks/pulseSurveys/useGetPulseSurveyFreeTextsInfinite'
import { PulseSurveysError } from 'containers/PulseSurveys/Error'

import { FreeTextQuestionProps } from './freeTextQuestion.types'

export const FreeTextQuestion = ({
    surveyUUID,
    questionId,
    questionTitle,
    questionType,
    colorBlindMode,
}: FreeTextQuestionProps) => {
    const { data, fetchNextPage, isFetchingNextPage, isLoading, isError } = useGetSingleFreeTextInfinite({
        surveyUUID,
        freeTextQuestionUUID: questionId,
        page: 1,
        page_size: questionType === 'short_answer' ? 10 : 5,
    })

    const paginatedData = useMemo(() => {
        if (!data || !data.pages || data.pages.length === 0) {
            return {
                items: [],
                total: 0,
                count: 0,
                page: 1,
                page_size: questionType === 'short_answer' ? 10 : 5,
            }
        }

        const allItems = data.pages.flatMap((page) => page.items || [])
        const latestPage = data.pages[data.pages.length - 1]

        return {
            items: allItems,
            total: latestPage.total || 0,
            count: allItems.length,
            page: latestPage.page || 1,
            page_size: latestPage.page_size || (questionType === 'short_answer' ? 10 : 5),
        }
    }, [data, questionType])

    if (isError) {
        return <PulseSurveysError />
    }

    return (
        <SurveyChartCard
            data={paginatedData}
            colorBlindMode={colorBlindMode}
            totalResponses={paginatedData.total}
            questionTitle={questionTitle}
            questionType={questionType}
            isLoading={isLoading}
            freeTextButtonProps={{
                onClick: () => fetchNextPage(),
                loading: isFetchingNextPage,
            }}
        />
    )
}
